
<mat-card class="card" [style.backgroundColor]="'#000c1d'">
<h1>About Us</h1>
<p>Five Point Strike was founded by Sean, an unremarkable white male with an undergraduate degree from a safety school.</p>
<p>Want to get in touch? Just shoot us an email at fivepointstrikeanalytics at gmail. Yes, we are looking for help. Yes, we do read hatemail. Yes, our humor is an acquired taste.</p>
</mat-card>